module.exports = __webpack_public_path__ + "img/T603.de1aa6cf.jpg";